import React from 'react';
import { CarouselCellFragment } from '../../generated/types/CarouselCellFragment';
import { NormalizePumoStyles } from '../NormalizePumoStyles';
import { DividerModule, DividerModuleProps } from '../DividerPumoModule';
import { SwiperCarousel } from '../SwiperCarousel';
import { CarouselCell } from '../Grid';
import './RecommendationsCarousel.scss';

interface Props {
  loading: boolean;
  error: Error | undefined;
  divider: DividerModuleProps;
  cells: CarouselCellFragment[];
}

export const RecommendationsCarousel: React.FC<Props> = ({ loading, error, divider, cells }) => {
  if (loading || error || cells.length === 0) return null;

  return (
    <>
      <NormalizePumoStyles className="RecommendationsCarousel">
        <DividerModule {...divider} />
      </NormalizePumoStyles>

      <SwiperCarousel>
        {cells.map((carouselCell, i) => (
          <CarouselCell key={i} carouselCell={carouselCell} />
        ))}
      </SwiperCarousel>
    </>
  );
};
